import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, type UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyMutations} from '../../api'
import type {ReportSummaryDto} from '../../types'
import {useRiskSurveyTranslation} from '../useRiskSurveyTranslation'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

type Variables = {
  reportId: string
}

export const useUnarchiveReport = (
  options?: UseMutationOptions<ReportSummaryDto, AxiosError, Variables>
) => {
  const {t} = useRiskSurveyTranslation()
  const queryClient = useQueryClient()

  return useMutation<ReportSummaryDto, AxiosError, Variables>({
    mutationFn: ({reportId}) => riskSurveyMutations.unarchiveReport(reportId),
    ...options,
    onSuccess: (data, variables, onMutateResult, context) => {
      spawnSuccessToast(t('archive.unarchiveSuccess'))
      void options?.onSuccess?.(data, variables, onMutateResult, context)
    },
    onError: (error, variables, onMutateResult, context) => {
      spawnErrorToast(t('archive.unarchiveError'))
      void options?.onError?.(error, variables, onMutateResult, context)
    },
    onSettled: (data, error, variables, onMutateResult, context) => {
      void queryClient.invalidateQueries({queryKey: riskSurveyQueryKeys.reports.lists()})
      void queryClient.invalidateQueries({
        queryKey: riskSurveyQueryKeys.reports.detail(variables.reportId)
      })
      void options?.onSettled?.(data, error, variables, onMutateResult, context)
    }
  })
}
